/* libs */
import React from "react";
import PropTypes from "prop-types";
import { SortableElement } from "react-sortable-hoc";

const SortableItem = SortableElement(props => {
	return <li className="sortable-item">{props.render}</li>;
});

SortableItem.propTypes = {
	title: PropTypes.string,
};

export default SortableItem;
